const identifierMap = {
  pubmed: 'PubMed',
  arxiv: 'arXiv'
};

export default (identifier = '') => {
  const ident = identifier.toLowerCase();
  return identifierMap[ident] || identifier.toUpperCase();
};



// WEBPACK FOOTER //
// ./src/universal/ui/utils/format-identifier-name.js